export function processingTime(createdAt, updatedAt) {
  if (!createdAt || !updatedAt) {
    return "Invalid dates";
  }

  const createdTime = new Date(createdAt);
  const updatedTime = new Date(updatedAt);

  const timeDiff = updatedTime - createdTime;

  const seconds = Math.floor((timeDiff / 1000) % 60);
  const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
  const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

  let result = "";
  if (days > 0) result += `${days} D, `;
  if (hours > 0) result += `${hours} H, `;
  if (minutes > 0) result += `${minutes} m, `;
  if (seconds > 0) result += `${seconds} s`;

  return result || "N/A";
}

export function formatTime(time) {
  const seconds = Math.floor(time % 60);
  const minutes = Math.floor((time / 60) % 60);
  const hours = Math.floor((time / (60 * 60)) % 24);
  const days = Math.floor(time / (60 * 60 * 24));

  let result = "";
  if (days > 0) result += `${days} D, `;
  if (hours > 0) result += `${hours} H, `;
  if (minutes > 0) result += `${minutes} m, `;
  if (seconds > 0) result += `${seconds} s`;

  return result || "N/A";
}
